import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-body" }
const _hoisted_2 = {
  key: 0,
  class: "page-title"
}
const _hoisted_3 = {
  key: 1,
  class: "page-content"
}
const _hoisted_4 = { class: "company" }
const _hoisted_5 = {
  key: 0,
  class: "brand"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "infos" }
const _hoisted_8 = {
  key: 0,
  class: "name"
}
const _hoisted_9 = {
  key: 1,
  class: "document"
}
const _hoisted_10 = {
  key: 2,
  class: "address"
}
const _hoisted_11 = {
  key: 3,
  class: "address"
}
const _hoisted_12 = {
  key: 2,
  class: "page-content"
}
const _hoisted_13 = { class: "employee" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 3,
  class: "page-content"
}
const _hoisted_16 = { class: "methods" }
const _hoisted_17 = ["innerHTML"]

import { computed, onBeforeUnmount, onMounted, ref, watchEffect } from "vue";
import { marked } from "marked";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";
import { paginateText, getMarkdownBlockHeights } from "@/common/utils/text";

import { analysisPDF } from "@/common/api/rest/analysis";
import type { AnalysisFullType } from "@/common/types/analysis";

import { pageExport } from "@/components";

interface ContentType {
  title: string | null;
  type: string;
  break: boolean;
  content: any;
}

interface PageType {
  page: number;
  content: {
    [key: string]: ContentType | null;
  } | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'analysis',
  props: {
    data: {},
    width: {},
    scale: {},
    footer: {}
  },
  setup(__props: any) {

const props = __props;

const { t, tm } = useI18n();

const route = useRoute();

const width = ref("210mm");
const height = ref(940);
const heightTitle = ref(52);

const analyse = ref<AnalysisFullType | null>(null);

const pages = ref<PageType[]>([]);

const summary = computed(
  () => tm("report.types.summary") as Record<string, string>
);

async function fetchData() {
  await analysisPDF(route.query.id as string, route.query.token as string)
    .then((response) => {
      const { success, data, message, code } = response;

      if (success) {
        analyse.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function paginate() {
  console.log("data", analyse.value);

  if (!analyse.value) return;

  pages.value = [];
  let PAGE = 0;
  let HEIGHT_INTERNAL = 0;

  pages.value.push({
    page: PAGE,
    content: {},
  });

  const paginateCompany = () => {
    if (!analyse.value!.company) return;

    HEIGHT_INTERNAL += heightTitle.value;

    const HEITHG_COMPANY_AVATAR = 90;
    let HEITHG_COMPANY = HEIGHT_INTERNAL + 0;

    const {
      avatar,
      name,
      document_name,
      document_number,
      address: addresses,
      address_id,
      contacts: contactsAll,
      contact_id,
    } = analyse.value!.company || {};

    pages.value[PAGE].content = {
      ...pages.value[PAGE].content,
      company: {
        title: null,
        type: "COMPANY",
        break: false,
        content: {
          avatar: avatar,
          name: null,
          document: null,
          address: null,
          contact: null,
        },
      },
    };

    const companyNameInfos = paginateText(name?.toUpperCase(), {
      width: "601px",
      height: height.value,
      font_size: "14px",
      line_height: "normal",
    });

    let documentText = "";

    if (document_name) documentText += document_name;
    if (document_number) documentText += ` ${document_number}`;

    const companyDocumentInfos = paginateText(documentText.toUpperCase(), {
      width: "601px",
      height: height.value,
      font_size: "14px",
      line_height: "normal",
    });

    const address = addresses?.filter(
      (item) => item.address_id === address_id
    )?.[0];

    let addressText = "";
    if (address?.address) addressText += address.address;
    if (address?.number) addressText += `, ${address.number}`;
    if (address?.complement) addressText += `, ${address.complement}`;
    if (address?.district) addressText += `, ${address.district}`;
    if (address?.city) addressText += `, ${address.city}`;
    if (address?.state) addressText += `, ${address.state}`;
    if (address?.country) addressText += `, ${address.country}`;
    if (address?.cep) addressText += `, CEP ${address.cep}`;

    const companyAdressInfos = paginateText(addressText.toUpperCase(), {
      width: "601px",
      height: height.value,
      font_size: "12px",
      line_height: "normal",
    });

    const contacts = contactsAll?.filter(
      (item) => item.contact_id === contact_id
    )?.[0];

    let contactText = "";
    if (contacts?.name) contactText += contacts.name;
    if (contacts?.contact) contactText += ` - ${contacts.contact}`;

    const companyContactInfos = paginateText(contactText.toUpperCase(), {
      width: "601px",
      height: height.value,
      font_size: "12px",
      line_height: "normal",
    });

    const companyNameHeight = companyNameInfos
      .map((item) => item.height)
      .reduce((prev, next) => prev + next, 0);

    const companyDocumentHeight = companyDocumentInfos
      .map((item) => item.height)
      .reduce((prev, next) => prev + next, 0);

    const companyAdressHeight = companyAdressInfos
      .map((item) => item.height)
      .reduce((prev, next) => prev + next, 0);

    const companyContactHeight = companyContactInfos
      .map((item) => item.height)
      .reduce((prev, next) => prev + next, 0);

    const HEITHG_COMPANY_INFOS =
      companyNameHeight +
      3 +
      companyDocumentHeight +
      3 +
      companyAdressHeight +
      3 +
      companyContactHeight;

    const HEIGHT_TOTAL = Math.max(HEITHG_COMPANY_AVATAR, HEITHG_COMPANY_INFOS);

    HEITHG_COMPANY += HEIGHT_TOTAL;

    if (HEITHG_COMPANY > height.value) {
      HEIGHT_INTERNAL = HEITHG_COMPANY;
      PAGE++;
      pages.value[PAGE] = {
        page: PAGE,
        content: {},
      };

      pages.value[PAGE].content = {
        ...pages.value[PAGE].content,
        company: {
          title: null,
          type: "COMPANY",
          break: true,
          content: {
            avatar: null,
            name: null,
            document: null,
            address: null,
            contact: null,
          },
        },
      };
    } else {
      HEIGHT_INTERNAL = HEITHG_COMPANY + 0;
    }

    pages.value[PAGE].content!.company!.content.name = companyNameInfos[0].text;
    pages.value[PAGE].content!.company!.content.document =
      companyDocumentInfos[0].text;
    pages.value[PAGE].content!.company!.content.address =
      companyAdressInfos[0].text;
    pages.value[PAGE].content!.company!.content.contact =
      companyContactInfos[0].text;
  };

  const paginateEmployee = () => {
    if (!analyse.value?.employee) return;

    const newPage = () => {
      PAGE++;
      pages.value[PAGE] = {
        page: PAGE,
        content: {},
      };
      HEIGHT_INTERNAL = 0;

      pages.value[PAGE].content = {
        ...pages.value[PAGE].content,
        employee: {
          title: t("report.titles.employee"),
          type: "EMPLOYEE",
          break: false,
          content: "",
        },
      };
    };

    HEIGHT_INTERNAL += heightTitle.value;

    pages.value[PAGE].content = {
      ...pages.value[PAGE].content,
      employee: {
        title: t("report.titles.employee"),
        type: "EMPLOYEE",
        break: false,
        content: "",
      },
    };

    let markText = "";

    const employee = analyse.value.employee;

    markText += `- **${t("employee.labels.social_name")}:**  ${employee.social_name}\n`;
  };

  const paginateMethod = () => {
    if (!analyse.value!.methods?.length) return;

    HEIGHT_INTERNAL += heightTitle.value;

    const newPage = () => {
      PAGE++;
      pages.value[PAGE] = {
        page: PAGE,
        content: {},
      };
      HEIGHT_INTERNAL = 0;
      // paginateCompany();

      pages.value[PAGE].content = {
        ...pages.value[PAGE].content,
        methods: {
          title: t("report.titles.methods"),
          type: "METHODS",
          break: false,
          content: [],
        },
      };
    };

    // INITILIZE PAGE
    pages.value[PAGE].content = {
      ...pages.value[PAGE].content,
      methods: {
        title: t("report.titles.methods"),
        type: "METHODS",
        break: false,
        content: "",
      },
    };

    let markText = "";

    analyse.value!.methods.forEach((item, index) => {
      markText += `#### ${item.code}\n`;
      markText += `${item.name}\n`;

      item.metadata?.forEach((field: any) => {
        if (field.type === "RANGE") {
          markText += `- **${field.name}:**  `;
          markText += `${t("question.labels.minimum")} ${field.min} ${field.measure}`;
          markText += "  |  ";
          markText += `${t("question.labels.maximum")} ${field.max} ${field.measure}\n`;
        } else {
          markText += `- **${field.name}:**  ${field.answer}\n`;
        }
      });

      if ((analyse.value.methods?.length ?? 0) > index + 1) {
        markText += "\n";
        markText += "---\n";
        markText += "\n";
      }
    });

    let methodText = "";
    markText.split("\n").forEach((text) => {
      HEIGHT_INTERNAL += 2;
      const pragraph = getMarkdownBlockHeights(text, {
        width: "617px",
        font_size: "14px",
        line_height: "normal",
      });

      if (HEIGHT_INTERNAL + pragraph[0]?.height > height.value) {
        pages.value[PAGE]!.content!.methods!.content = marked(methodText);
        newPage();
        HEIGHT_INTERNAL += pragraph[0]?.height ?? 0;
        methodText = `${text}\n`;
      } else {
        HEIGHT_INTERNAL += pragraph[0]?.height ?? 0;
        methodText += `${text}\n`;
      }
    });

    if (methodText.length) {
      pages.value[PAGE]!.content!.methods!.content = marked(methodText);
    }
  };

  paginateCompany();
  console.log("height-company", HEIGHT_INTERNAL);
  paginateEmployee();
  console.log("height-employee", HEIGHT_INTERNAL);
  paginateMethod();
  console.log("height-method", HEIGHT_INTERNAL);

  console.log("pages", pages.value);
}

watchEffect(() => {
  paginate();
});

onBeforeUnmount(() => {
  document.body.style.background = "#e4e4e4";
});

onMounted(() => {
  document.body.style.background = "white";
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page) => {
    return (_openBlock(), _createBlock(_unref(pageExport), {
      key: page.page,
      width: width.value,
      page: page.page + 1,
      scale: __props.scale,
      "show-footer": __props.footer?.visible,
      "footer-title": __props.footer?.title,
      "footer-subtitle": __props.footer?.subtitle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(page.content!), (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item!.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item!.title), 1))
                : _createCommentVNode("", true),
              (item!.type === 'COMPANY')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (item!.content.avatar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("img", {
                              src: item!.content.avatar.base64
                            }, null, 8, _hoisted_6)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, [
                        (item!.content.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item!.content.name), 1))
                          : _createCommentVNode("", true),
                        (item!.content.document)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item!.content.document), 1))
                          : _createCommentVNode("", true),
                        (item!.content.address)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item!.content.address), 1))
                          : _createCommentVNode("", true),
                        (item!.content.contact)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item!.content.contact), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item!.type === 'EMPLOYEE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        innerHTML: item!.content
                      }, null, 8, _hoisted_14)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item!.type === 'METHODS')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        innerHTML: item!.content
                      }, null, 8, _hoisted_17)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _: 2
    }, 1032, ["width", "page", "scale", "show-footer", "footer-title", "footer-subtitle"]))
  }), 128))
}
}

})